import { FunctionComponent } from 'react';
import styles from './OnboardingTemplate.module.scss';
import classNames from 'classnames';

interface OnboardingTemplateProps extends React.PropsWithChildren {
  sidebar?: React.ReactElement;
  footer?: React.ReactElement;
}

const OnboardingTemplate: FunctionComponent<OnboardingTemplateProps> = ({ sidebar, footer, children }) => {
  return (
    <section className={styles['template']}>
      <div className={classNames(styles['background'], 'background')}></div>

      <div className={styles['layout']}>
        {sidebar && <aside className={styles['sidebar']}>{sidebar}</aside>}

        <main className={styles['main']}>
          <div className={styles['main__content']}>{children}</div>

          {footer && (
            <footer className={styles['main__footer']}>
              <div className={styles['main__footer__inner']}>{footer}</div>
            </footer>
          )}
        </main>
      </div>
    </section>
  );
};

export default OnboardingTemplate;
